__turbopack_context__.v({
  "callout": "Callout-module-scss-module__2-yhRW__callout",
  "icon": "Callout-module-scss-module__2-yhRW__icon",
  "messageWrapper": "Callout-module-scss-module__2-yhRW__messageWrapper",
});
